import AnnualSummaryService from '../../service/AnnualSummaryService'

const initialState = {
    blocks: [],
    icons: [],
    calculations: [],
    activeBlock: {},
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async sendAnnualSummaryEmail({ dispatch }) {
            try {
                const resp = await AnnualSummaryService.sendEmail();
                if (resp.status === 200) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Email was sent",
                            type: "success"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },
        async fetchBlocks({ commit }) {
            try {
                const resp = await AnnualSummaryService.getBlocks()
                if (resp.status === 200) {
                    commit('setBlocks', resp.data.blocks)
                    commit('setIcons', resp.data.icons)
                    commit('setCalculations', resp.data.calculations)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchBlockTables({ commit }, { blockId }) {
            try {
                const resp = await AnnualSummaryService.getBlockTables({ blockId })
                if (resp.status === 200) {
                    commit('setActiveBlock', { blockId: blockId, data: resp.data.tables })
                }
            } catch (e) {
                console.log(e)
            }
        },
        async saveBlockTable({ state, dispatch }, { blockId, tableId }) {
            let isSuccessful = false
            try {
                const table = state.activeBlock.tables.find(t => t.id === tableId)
                const resp = await AnnualSummaryService.saveBlockTable({
                    blockId: blockId,
                    data: table,
                    tableId: tableId,
                })
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Successfully saved',
                            type: 'success',
                        },
                        { root: true }
                    )
                    isSuccessful = true
                } else {
                    let message = 'Failed'

                    if (resp && resp.msg) {
                        message = resp.msg
                    }

                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }

            return isSuccessful
        },
        async deleteBlockTable({ dispatch }, { blockId, tableId }) {
            let isSuccessful = false
            try {
                const resp = await AnnualSummaryService.deleteBlockTable({ blockId: blockId, tableId: tableId })
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Successfully saved',
                            type: 'success',
                        },
                        { root: true }
                    )
                    isSuccessful = true
                } else {
                    let message = 'Failed'

                    if (resp && resp.msg) {
                        message = resp.msg
                    }

                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }

            return isSuccessful
        },
        async saveBlockTableSortOrder({ state, dispatch }, { blockId }) {
            try {
                const resp = await AnnualSummaryService.saveBlockTablesSortOrder({
                    blockId: blockId,
                    data: state.activeBlock,
                })
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Sort order saved',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }
        },
        async recalculateAnnualSummary({ dispatch }, { tableId }) {
            let isSuccessful = false
            try {
                const resp = await AnnualSummaryService.recalculateAnnualSummary({ tableId: tableId })
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Successfully started recalculation',
                            type: 'success',
                        },
                        { root: true }
                    )
                    isSuccessful = true
                } else {
                    let message = 'Failed'

                    if (resp && resp.msg) {
                        message = resp.msg
                    }

                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
            }

            return isSuccessful
        },
    },
    mutations: {
        setBlocks(state, data) {
            state.blocks = data
        },
        setIcons(state, data) {
            state.icons = data
        },
        setCalculations(state, data) {
            state.calculations = data
        },
        resetBlocks(state) {
            state.blocks = []
        },
        setActiveBlock(state, { blockId, data }) {
            state.activeBlock = {
                block_id: blockId,
                tables: data,
            }
        },
        resetActiveBlock(state) {
            state.activeBlock = {}
        },
        setActiveBlockTables(state, value) {
            state.activeBlock.tables = value
        },
        addNewBlockTableRow(state) {
            const id = `x-${Math.floor(Math.random() * (3000 - 1) + 1)}`
            state.activeBlock.tables.push({
                id: id,
                formula: null,
                title: '',
                subtitle: null,
                start_date: null,
                end_date: null,
                has_graph: false,
                value_decimal_places: 0,
                icon: 'crop',
                formula_type: 'value',
                ignore_zero_values: 0,
                show_variable_as_result: 0,
                variable_as_result: null,
                variable_as_result_method: 'average',
                calculation_idx: null,
                titles: {
                    en: null,
                    et: null,
                    fi: null,
                    lt: null,
                },
                subtitles: {
                    en: null,
                    et: null,
                    fi: null,
                    lt: null,
                },
                boolean_yes_answers: {
                    en: null,
                    et: null,
                    fi: null,
                    lt: null,
                },
                boolean_no_answers: {
                    en: null,
                    et: null,
                    fi: null,
                    lt: null,
                },
            })
        },
    },
    getters: {},
}
